<script>
import { GlIcon, GlLink, GlSkeletonLoader } from '@gitlab/ui';
import TimeAgoTooltip from '~/vue_shared/components/time_ago_tooltip.vue';
import AgentStatusBadge from 'ee/ai/shared/widgets/agent_status_badge.vue';
import AgentFlowTriggeredUser from '../../../components/common/agent_flow_triggered_user.vue';

export default {
  name: 'AgentFlowHeader',
  components: {
    GlIcon,
    GlLink,
    GlSkeletonLoader,
    TimeAgoTooltip,
    AgentStatusBadge,
    AgentFlowTriggeredUser,
  },
  props: {
    isLoading: {
      required: true,
      type: Boolean,
    },
    title: {
      required: false,
      type: String,
      default: '',
    },
    isSidePanelView: {
      type: Boolean,
      required: false,
      default: false,
    },
    status: {
      type: String,
      required: false,
      default: null,
    },
    humanStatus: {
      type: String,
      required: false,
      default: null,
    },
    updatedAt: {
      type: String,
      required: false,
      default: '',
    },
    project: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    validUpdatedAt() {
      if (!this.updatedAt) return null;
      const date = new Date(this.updatedAt);
      return Number.isNaN(date.getTime()) ? null : this.updatedAt;
    },
    projectName() {
      return this.project?.name || null;
    },
    projectWebPath() {
      return this.project?.webPath || null;
    },
  },
};
</script>
<template>
  <div v-if="isLoading">
    <gl-skeleton-loader class="gl-px-4" :lines="1" :width="400" />
  </div>
  <header
    v-else-if="isSidePanelView"
    class="gl-sticky gl-top-0 gl-z-9999 gl-shrink-0 gl-bg-default gl-p-0"
  >
    <div
      class="drawer-title gl-border-b gl-flex gl-items-center gl-justify-start gl-px-4 gl-pb-3 gl-pt-2"
    >
      <div
        class="gl-flex gl-w-full gl-grow gl-flex-col gl-justify-center gl-gap-2 gl-text-sm gl-text-subtle"
      >
        <div class="gl-flex gl-w-full gl-items-center gl-justify-between">
          <span class="gl-flex gl-gap-4">
            <agent-status-badge v-if="status" :status="status" :human-status="humanStatus" />
            <time-ago-tooltip
              v-if="validUpdatedAt"
              :time="validUpdatedAt"
              class="gl-mt-1"
              data-testid="agent-flow-last-updated"
            >
              <template #default="{ timeAgo }">{{
                sprintf(s__('DuoAgentsPlatform|Updated %{timeago}'), { timeago: timeAgo })
              }}</template>
            </time-ago-tooltip>
          </span>
        </div>
        <div class="gl-mt-3 gl-flex gl-items-center gl-gap-4">
          <span class="gl-flex gl-items-center gl-gap-2">
            <template v-if="projectName">
              <gl-icon name="project" variant="subtle" size="14" />
              <gl-link
                v-if="projectWebPath"
                :href="projectWebPath"
                data-testid="agent-flow-project-name"
                class="gl-text-subtle hover:gl-text-subtle"
                >{{ projectName }}</gl-link
              >
              <span v-else data-testid="agent-flow-project-name">{{ projectName }}</span>
            </template>
          </span>
          <agent-flow-triggered-user :user="user" />
        </div>
      </div>
    </div>
  </header>
  <header v-else class="gl-flex gl-items-center gl-gap-2">
    <h1 class="gl-heading-1 gl-m-0" data-testid="agent-flow-page-title">{{ title }}</h1>
  </header>
</template>
